export default __webpack_public_path__ + "static/media/deadwood.194ad539.PNG";